var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.socials && _vm.socials.length)?_c('div',{staticClass:"socials"},_vm._l((_vm.socials),function(item,i){return _c('a',{key:i,attrs:{"href":item.link,"target":"_blank","rel":"nofollow"}},[_c('figure',{staticClass:"icon",domProps:{"innerHTML":_vm._s(item.value)}})])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }